<template>
    <v-container v-if="application">
		<QApplicationPdfPreview
			:key="applicationKey"
			:application="application"
			:secure="secure"
		/>
	</v-container>
</template>

<script>
import QApplicationPdfPreview from '@/components/utils/QApplicationPdfPreview.vue'

export default {
	components: {
        QApplicationPdfPreview,
    },
    data () {
        return {
			application: null,
			secure: false,
        }
    },
    mounted () {
		this.getRouteData()
    },
	watch: {
		'$route.fullPath' () {
			if (this.$route.name !== 'ApplicationsPdfPreview') { return }
			this.getRouteData()
		},
	},
    computed: {
		applicationKey () {
			if (!this.application) { return 'application-key' }
			return Object.values(this.application).filter(Boolean).join('-')
		},
    },
    methods: {
		getRouteData () {
			const { query } = this.$route
			this.secure = query.secure === 'true'
			this.application = {
				id: query.id,
				link: query.link,
			}
		}
	},
}
</script>
